export default __webpack_public_path__ + "static/media/therion.33716441.webp";